<template>
  <div class="fill-height">
    <FufuHeader :shop="null">
      {{ isLoading ? 'Loading...' : '誕生日の設定' }}
    </FufuHeader>
    <v-container class="white" fill-height fluid>
      <v-progress-circular
        v-if="isLoading"
        color="primary"
        indeterminate
        class="mx-auto"
        :size="50"
      />
      <v-layout v-else column>
        <v-flex>
          <v-layout justify-center align-center fill-height column>
            <p class="subtitle-1">
              <b>ご予約ありがとうございました。</b>
            </p>
            <p>
              <b>お誕生日のご登録にご協力ください。</b>
            </p>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-card flat>
            <v-card-text class="text-center">
              {{ countdown }}秒後に自動でトップページへ戻ります。
            </v-card-text>

            <v-form ref="form" v-model="valid" class="form">
              <v-layout justify-center>
                <v-text-field
                  v-model.number="form.year"
                  class="year"
                  label="西暦"
                  type="number"
                  outlined
                  style="max-width: 200px"
                  :rules="yearRules"
                  @input="onYearInput"
                />
                <v-text-field
                  v-model.number="form.month"
                  class="month"
                  label="月"
                  min="1"
                  max="12"
                  type="number"
                  outlined
                  style="max-width: 150px"
                  :rules="monthRules"
                  @input="onMonthInput"
                />
                <v-text-field
                  v-model.number="form.day"
                  class="day"
                  label="日"
                  min="1"
                  max="31"
                  type="number"
                  style="max-width: 150px"
                  outlined
                  :rules="dayRules.concat([checkDay])"
                  @keypress.enter="valid && submit()"
                />
              </v-layout>
            </v-form>

            <v-card-actions class="text-center">
              <v-btn
                color="primary"
                class="mx-auto"
                :disabled="!valid"
                :loading="submiting"
                @click="submit"
              >
                登録
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex class="text-center">
          <v-btn text color="primary" large replace @click="goDone">
            <v-icon>mdi-chevron-right</v-icon>
            <b>登録しない</b>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import FufuHeader from '@/components/FufuHeader'

const TIMER = 120 // sec
export default {
  name: 'BirthdayInputView',
  components: {
    FufuHeader,
  },
  props: {
    mode: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    valid: false,
    timerId: null,
    intervalId: null,
    customer: null,
    isLoading: true,
    submiting: false,
    countdown: TIMER,
    form: {
      year: null,
      month: null,
      day: null,
    },
    yearRules: [v => Boolean(v) || 'この項目は必須です'],
    monthRules: [
      v => Boolean(v) || 'この項目は必須です',
      v => (1 <= v && v <= 12) || '1から12までの値を入力してください',
    ],
    dayRules: [v => Boolean(v) || 'この項目は必須です'],
  }),
  created() {
    this.fetchData()
  },
  mounted() {
    const start = new Date().getTime()
    this.timerId = setTimeout(() => {
      this.$router.replace('/Done')
    }, TIMER * 1000)
    this.intervalId = setInterval(() => {
      this.countdown = TIMER - Math.ceil((new Date().getTime() - start) / 1000)
    }, 200)
  },
  beforeDestroy() {
    if (this.timerId) clearTimeout(this.timerId)
    if (this.intervalId) clearInterval(this.intervalId)
  },
  methods: {
    async fetchData() {
      try {
        this.customer = await this.$api
          .customers(this.$route.params.customerId)
          .get()
        if (this.customer.birthday) {
          this.goDone()
        } else {
          this.isLoading = false
        }
      } catch (err) {
        this.goDone()
      }
    },
    async submit() {
      this.submiting = true
      try {
        const form = this.form
        let y = String(form.year)
        let m = String(form.month)
        let d = String(form.day)
        if (m.length < 2) m = '0' + m
        if (d.length < 2) d = '0' + d
        const birthday = `${y}-${m}-${d}`
        await this.$api
          .customers(this.$route.params.customerId)
          .partialUpdate({ birthday })
        this.goDone()
      } catch (err) {
        this.$toast.error('誕生日の登録に失敗しました。')
        this.submiting = false
      }
    },
    checkDay(v) {
      let max = 31
      const m = this.form.month
      switch (m) {
        case 2:
          max = 29
          break
        case 4:
        case 6:
        case 9:
        case 11:
          max = 30
      }
      return (1 <= v && v <= max) || `1から${max}までの値を入力してください`
    },

    onYearInput(x) {
      if (String(x).length === 4) {
        const input = document.querySelector('.month input')
        if (input) input.focus()
      }
    },
    onMonthInput(v) {
      if (2 < v) {
        const input = document.querySelector('.day input')
        if (input) input.focus()
      }
    },
    goDone() {
      this.$router.replace({
        name: 'Done',
        query: {
          shop: this.$route.query.shop,
          result: this.$route.query.result,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form::v-deep input::-webkit-outer-spin-button,
.form::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
